import { WorkOrder } from "@/services/backend/vbs/work-orders/types/work-order";
import { useState } from "react";
import {
  UpdateBeginDateRequest,
  useVbsWorkOrderUpdateBeginDateMutation,
} from "@/services/backend/vbs/work-orders/api/work-order-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import t from "@/lang/lang";
import { DatetimePickerField } from "@/shared/components/field/date-picker-field";

export function WorkOrderBeginDateInput({
  workOrder,
  disabled = false,
}: {
  workOrder: WorkOrder;
  disabled?: boolean;
}) {
  const [request, setRequest] = useState<UpdateBeginDateRequest>({
    id: workOrder.id,
    beginDate: workOrder.beginDate,
  });
  const mutation = useVbsWorkOrderUpdateBeginDateMutation();
  useDebouncedMutation(request, setRequest, mutation, {
    id: workOrder.id,
    beginDate: workOrder.beginDate,
  });

  return (
    <DatetimePickerField
      label={t("Beginn der Arbeiten")}
      nullable
      date={request.beginDate || undefined}
      onDateChange={(beginDate) =>
        setRequest({ ...request, beginDate: beginDate ?? "" })
      }
      fieldName="beginDate"
      disabled={disabled}
    />
  );
}
